import { CanDeactivateFn } from '@angular/router';
import { AccountQuestionnaireDetailsPageComponent } from '../pages/account';

export const accountQuestionnaireDetailsPendingChangesGuard: CanDeactivateFn<
  AccountQuestionnaireDetailsPageComponent
> = (component) => component.canDeactivate();
